import React from "react";
import styled from "styled-components";
import {Field} from "formik";

const CounterInputFormik = ({name, step}) => {
    return (
            <Container
                type="number"
                name={name}
                step={step}
                min={0}
            />
    )
}

const Container = styled(Field)`
  display: flex;
  flex-direction: row;
  padding:0.5rem;
  border-radius: 5px;
  width: auto;
  border: 1px rgba(166, 172, 181, 0.6) solid;
 ::-webkit-inner-spin-button {
   opacity: 1;
   -moz-appearance: textfield;
   margin: 0;
 }
`

export default CounterInputFormik
